import { clsx } from "@frend-digital/ui";
import {
  Children,
  type ComponentProps,
  type DetailedReactHTMLElement,
  cloneElement,
  memo,
} from "react";

type SlotProps = ComponentProps<"div" | "button" | "a">;

export function SlotBase<
  P extends { className?: string; style?: React.CSSProperties } = SlotProps,
>({ children, ...props }: SlotProps) {
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let SingleChild = null as DetailedReactHTMLElement<P, any> | null;

  try {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    SingleChild = Children.only(children) as DetailedReactHTMLElement<P, any>;
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error(
        "Slot component must have exactly one child, got",
        children,
      );
      throw error;
    }
  }

  if (!SingleChild) {
    console.warn("Slot component must have exactly one child");
    return null;
  }

  return cloneElement(SingleChild, {
    ...props,
    className: clsx(SingleChild.props?.className, props?.className),
    style: { ...SingleChild.props?.style, ...props?.style },
    onClick: e => {
      if (
        "onClick" in SingleChild.props &&
        typeof SingleChild.props.onClick === "function"
      ) {
        SingleChild.props.onClick(e);
      }
      if (props.onClick) {
        props.onClick(e);
      }
    },
  });
}

export const Slot = memo(SlotBase);
